module.exports = __webpack_public_path__ + "img/perforaciones_16-9_1920.f17953e7.jpg";